/* tslint:disable:no-bitwise */
export enum ActionKind {
  ACTION_KIND_MESSAGE = 1 << 0,
  ACTION_KIND_ACTION = 1 << 1
}
